module.exports = __webpack_public_path__ + "img/guan-new3.c65e229a.png";